import Route from 'vue-routisan';

// 인증을 위해 사용될 함수 추후 적용.
function requireAuth (to, from, next) {
    if (store.state.token === '') {
        next({
            path: 'auth/login',
            query: {redirect: to.fullPath}
        })
    } else {
        next()
    }
}
// 기초 라우터 세팅
Route.setViewResolver((component) => {
    return require('../views/' + component).default;
});

// Route.view('/','dashboard/Dashboard').options({
//   meta: { name : 'Dashboard', title: '대시보드', arrow: true }
// });
// Route.view('/nft/dash','dashboard/NftDashboard').options({
//     meta: { name : 'NftDashboard', title: 'NFT대시보드', arrow: false }
// });
Route.view('/', 'member/Member').options({// 로그인
  meta: { name : 'Member', title: '회원목록', arrow: true }
});

// 로그인 | 회원가입
Route.group({prefix: '/auth'}, ()=>{
  Route.view('/', 'auth/Login').options({// 로그인
    meta: { name : 'Login', title: '로그인', arrow: false }
  });
});

Route.group({prefix: '/member'}, ()=>{
  Route.view('/', 'member/Member').options({
      meta: { name : 'Member', title: '회원목록', arrow: true }
  });
  Route.group({prefix: '/detail'}, ()=> {
      Route.view('/', 'member/MemberCreate').options({
        meta: { name : 'MemberCreate', title: '회원 등록', arrow: true}
      });
      Route.group({prefix: ':mb_no'}, () => {
          Route.view('/', 'member/MemberCreate').options({
              meta: { name : 'MemberModify', title: '회원 수정', arrow: true}
          });
      });
  });
});
Route.group({prefix: '/admin'}, ()=>{
	Route.view('/', 'admin/Admin').options({
		meta: { name : 'Admin', title: '관리자회원목록', arrow: true }
	});
	Route.group({prefix: '/detail'}, ()=> {
		Route.view('/', 'admin/AdminCreate').options({
		  meta: { name : 'AdminCreate', title: '부관리자 등록', arrow: true}
		});
		Route.group({prefix: ':mb_no'}, () => {
			Route.view('/', 'admin/AdminCreate').options({
				meta: { name : 'AdminModify', title: '부관리자 수정', arrow: true}
			});
		});
	});
  });
Route.group({prefix: '/license'}, ()=>{
	Route.view('/', 'license/License').options({
		meta: { name : 'License', title: '라이센스목록', arrow: true }
	});
    Route.group({prefix: '/detail'}, ()=> {
        Route.view('/', 'license/LicenseDetail').options({
          meta: { name : 'LicenseCreate', title: '라이센스 등록', arrow: true}
        });
        Route.group({prefix: ':pl_idx'}, () => {
            Route.view('/', 'license/LicenseDetail').options({
                meta: { name : 'LicenseModify', title: '라이센스 수정', arrow: true}
			});
            Route.view('/product', 'product/Product').options({
                meta: { name : 'LicenseProduct', title: '제품목록', arrow: true}
			});
        });
    });
});

Route.group({prefix: '/product'}, ()=>{
  Route.view('/', 'product/Product').options({
      meta: { name : 'Product', title: '제품목록', arrow: true }
  });
});

Route.group({prefix: '/method'}, ()=>{
    Route.view('/', 'method/Method').options({
        meta: { name : 'Method', title: '사용법', arrow: true }
    });
    Route.group({prefix: '/detail'}, ()=> {
        Route.view('/', 'method/MethodCreate').options({
          meta: { name : 'MethodCreate', title: '사용법 등록', arrow: true}
        });
        Route.group({prefix: ':v_idx'}, () => {
            Route.view('/', 'method/MethodCreate').options({
                meta: { name : 'MethodModify', title: '사용법 수정', arrow: true}
            });
        });
    });
});

// 안전 정보
Route.group({prefix: '/help'}, ()=>{
    Route.view('/', 'help/Safety').options({
        meta: { name : 'Safety', title: '안전정보', arrow: true }
    });
    Route.group({prefix: '/detail'}, ()=> {
        Route.view('/', 'help/SafetyCreate').options({
          meta: { name : 'SafetyCreate', title: '안전정보 등록', arrow: true}
        });
        Route.group({prefix: ':wr_id'}, () => {
            Route.view('/', 'help/SafetyCreate').options({
                meta: { name : 'SafetyModify', title: '안전정보 수정', arrow: true}
            });
        });
    });
});

/*
Route.group({prefix: '/examples'}, ()=>{
  Route.view('/', 'examples/Example').options({
    meta: { name : 'Example', title: '활용예시', arrow: true }
  });
  Route.group({prefix: '/detail'}, ()=> {
    Route.view('/', 'examples/ExampleCreate').options({
      meta: { name : 'ExampleCreate', title: '활용예시 등록', arrow: true}
    });
    Route.group({prefix: ':e_idx'}, () => {
      Route.view('/', 'examples/ExampleCreate').options({
        meta: { name : 'ExampleModify', title: '활용예시 수정', arrow: true}
      });
    });
  });
});
*/

// 위치정보 로그
Route.group({prefix: '/location'}, ()=>{
  Route.view('/', 'location/LocationLog').options({
    meta: { name : 'location', title: '위치정보', arrow: true }
  });
});

// 관리자 로그
/*Route.group({prefix: '/memberlog'}, ()=>{
  Route.view('/', 'member/MemberLog').options({
    meta: { name : 'MemberLog', title: '관리자 로그', arrow: true }
  });
});*/

// 게시판
Route.group({prefix: '/board'}, ()=>{
  Route.group({prefix: '/notice'}, ()=> {
    Route.view('/', 'board/notice/Notice').options({
      meta: { name : 'Notice', title: '공지사항', arrow: true}
    });
    Route.group({prefix: '/detail'}, ()=> {
      Route.view('/', 'board/notice/NoticeCreate').options({
        meta: { name : 'NoticeCreate', title: '공지사항 등록', arrow: true}
      });
      Route.group({prefix: ':wr_id'}, () => {
        Route.view('/', 'board/notice/NoticeCreate').options({
          meta: { name : 'NoticeModify', title: '공지사항 수정', arrow: true}
        });
      });
    });
  });
  Route.group({prefix: '/faq'}, ()=> {
    Route.view('/', 'board/faq/Faq').options({
      meta: { name : 'Faq', title: 'faq', arrow: true}
    });
    Route.group({prefix: '/detail'}, ()=> {
      Route.view('/', 'board/faq/FaqCreate').options({
        meta: { name : 'FaqCreate', title: 'faq 등록', arrow: true}
      });
      Route.group({prefix: ':fa_idx'}, () => {
        Route.view('/', 'board/faq/FaqCreate').options({
          meta: { name : 'FaqModify', title: 'faq 수정', arrow: true}
        });
      });
    });
  });
  Route.group({prefix: '/qa'}, ()=> {
    Route.view('/', 'board/qa/Qa').options({
      meta: { name : 'Qa', title: '문의하기', arrow: true}
    });
    Route.group({prefix: '/detail'}, ()=> {
      Route.view('/', 'board/qa/QaDetail').options({
        meta: { name : 'QaDetail', title: '문의 등록', arrow: true}
      });
      Route.group({prefix: ':qq_idx'}, () => {
        Route.view('/', 'board/qa/QaDetail').options({
          meta: { name : 'QaDetail', title: '문의 등록/수정', arrow: true}
        });
      });
    });
  });
  Route.group({prefix: '/QaProduct'}, ()=> {
    Route.view('/', 'board/qa/QaProduct').options({
      meta: { name : 'QaProduct', title: '제품 문의하기', arrow: true}
    });
    Route.group({prefix: '/detail'}, ()=> {
      Route.view('/', 'board/qa/QaProductDetail').options({
        meta: { name : 'QaProductDetail', title: '제품 문의 등록', arrow: true}
      });
      Route.group({prefix: ':qq_idx'}, () => {
        Route.view('/', 'board/qa/QaProductDetail').options({
          meta: { name : 'QaProductDetail', title: '제품 문의 등록/수정', arrow: true}
        });
      });
    });
  });


});

// 세팅
Route.group({prefix: '/setting'}, ()=>{

  Route.group({prefix: '/agree'}, ()=> {
    Route.view('/', 'setting/agree/Agree').options({
      meta: { name : 'Agree', title: '이용약관', arrow: true}
    });
    Route.group({prefix: '/detail'}, ()=> {
      Route.view('/', 'setting/agree/AgreeCreate').options({
        meta: { name : 'AgreeCreate', title: '이용약관 등록', arrow: true}
      });
      Route.group({prefix: ':cs_idx'}, () => {
        Route.view('/', 'setting/agree/AgreeCreate').options({
          meta: { name : 'AgreeModify', title: '이용약관 수정', arrow: true}
        });
      });
    });
  });

  Route.group({prefix: '/policy'}, ()=> {
    Route.view('/', 'setting/policy/Policy').options({
      meta: { name : 'Policy', title: '개인정보 처리방침', arrow: true}
    });
    Route.group({prefix: '/detail'}, ()=> {
      Route.view('/', 'setting/policy/PolicyCreate').options({
        meta: { name : 'PolicyCreate', title: '개인정보 처리방침 등록', arrow: true}
      });
      Route.group({prefix: ':cs_idx'}, () => {
        Route.view('/', 'setting/policy/PolicyCreate').options({
          meta: { name : 'PolicyModify', title: '개인정보 처리방침 수정', arrow: true}
        });
      });
    });
  });
  Route.group({prefix: '/position'}, ()=> {
    Route.view('/', 'setting/position/PositionAgree').options({
      meta: { name : 'PositionAgree', title: '위치기반 서비스 이용약관', arrow: true}
    });
    Route.group({prefix: '/detail'}, ()=> {
      Route.view('/', 'setting/position/PositionAgreeCreate').options({
        meta: { name : 'PositionAgreeCreate', title: '위치기반 서비스 등록', arrow: true}
      });
      Route.group({prefix: ':cs_idx'}, () => {
        Route.view('/', 'setting/position/PositionAgreeCreate').options({
          meta: { name : 'PositionAgreeModify', title: '위치기반 서비스 수정', arrow: true}
        });
      });
    });
  });
});

 //서비스관리
//  Route.group('/popup', 'Home').options({meta: {sideName: '팝업관리', icon_name: 'service'}}).children(()=>{
//   Route.view('/', 'popup/Popup').options({
//     meta: {name: 'ServicePopup', title: '팝업관리', sideName: '팝업관리'}
//   });
//   Route.group('detail', 'Home').options({meta: {sideHidden: true, name: 'ServicePopup'}}).children(() => {
//     Route.view('', 'popup/PopupDetail').options({
//       meta: { name: 'ServicePopup', title: '팝업 발송', sideHidden: true}
//     });
//     Route.view(':v_idx', 'popup/PopupDetail').options({
//       meta: { name: 'ServicePopup', title: '팝업 수정', sideHidden: true }
//     });
//   });
// });

Route.group({prefix: '/popup'}, ()=>{
  Route.view('/', 'popup/Popup').options({
      meta: { name : 'Popup', title: '팝업관리', arrow: true }
  });
  Route.group({prefix: '/detail'}, ()=> {
      Route.view('/', 'popup/PopupDetail').options({
        meta: { name : 'PopupCreate', title: '팝업관리 등록', arrow: true}
      });
      Route.group({prefix: ':p_idx'}, () => {
          Route.view('/', 'popup/PopupDetail').options({
              meta: { name : 'PopupModify', title: '팝업관리 수정', arrow: true}
          });
      });
  });
});
Route.group({prefix: '/policy'}, ()=>{
    Route.view('/', 'policy/PrivacyView').options({
        meta: { name : 'policy', title: '개인정보처리방침', arrow: true }
    });
});
Route.group({prefix: '/safety/alert'}, ()=> {
  Route.view('/', 'alert/Alert').options({
    meta: { name : 'Alert', title: '생산관리', arrow: true }
  });
})




export default Route.all();
